function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 29,
  fill: "#d8d9d8",
  r: 29
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m34.962 16h-11.924c-3.8808 0-7.038 3.1572-7.038 7.038v11.9242c0 3.8806 3.1572 7.0378 7.038 7.0378h11.9242c3.8806 0 7.0378-3.1572 7.0378-7.0378v-11.9242c0-3.8808-3.1572-7.038-7.038-7.038zm-5.962 20.1091c-3.9201 0-7.1092-3.1891-7.1092-7.1091 0-3.9201 3.1891-7.1092 7.1092-7.1092 3.92 0 7.1091 3.1891 7.1091 7.1092 0 3.92-3.1891 7.1091-7.1091 7.1091zm7.2791-12.5417c-1.1584 0-2.1006-.9422-2.1006-2.1007 0-1.1584.9422-2.1009 2.1006-2.1009 1.1585 0 2.1009.9425 2.1009 2.1009 0 1.1585-.9424 2.1007-2.1009 2.1007z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m28.9998 23.4149c-3.0794 0-5.5849 2.5053-5.5849 5.5849 0 3.0794 2.5055 5.5849 5.5849 5.5849 3.0796 0 5.5849-2.5055 5.5849-5.5849 0-3.0796-2.5053-5.5849-5.5849-5.5849z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m36.2788 20.8905c-.3178 0-.5765.2586-.5765.5764s.2587.5765.5765.5765c.318 0 .5766-.2585.5766-.5765s-.2586-.5764-.5766-.5764z",
  fill: "#fff"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 58,
    viewBox: "0 0 58 58",
    width: 58,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.0165c1db.svg";
export { ForwardRef as ReactComponent };